import React, { useEffect, useState } from 'react'
import * as opdRegisteredCrud from '../../../configurations/crud/opdRegisteredCrud'
import { useToast } from '../../controls/Toast/ToastService';
import { MdErrorOutline } from 'react-icons/md';
import { Link, useParams } from 'react-router-dom';
import { PAGE_SIZE } from '../../../configurations/initUrls';
import Paging from '../../controls/Paging';
import ConfirmOnline from './ConfirmOnline';
import { EOPDRegisteredStatusBg, GetEOPDRegisterstatus, GetEOPDRegisterStatusName } from '../../../configurations/enums/EOPDRegisteredStatus';
import StatusContainer from '../../controls/StatusContainer';
import { IoCheckmarkCircleOutline } from 'react-icons/io5';
import LoadingContainer from '../../controls/LoadingContainer';
import { GetEGenderName } from '../../../configurations/enums/EGender';
import useGlobalLoader from '../../../configurations/useGlobalLoader';
import Empty from '../../controls/Empty';

export default function LookOutRegistered({ isActive, searchTerm, isSearch, centerId, forDate }) {

    const { start, end } = useGlobalLoader()
    const toast = useToast()
    const [LastPage, setLastPage] = useState(1);
    const [pagingData, setPagingData] = useState();
    const [loding, setLoding] = useState(false)
    const [userData, setUserData] = useState([]);
    const [lodingCrud, setLodingCrud] = useState(false)
    const [isOpenAdd, setIsOpenAdd] = useState(false)
    const [addData, setAddData] = useState()
    const [currentPage, setCurrentPage] = useState(1)

    useEffect(() => {
        if (isActive && centerId && forDate) {
            onSearch()
        }
    }, [isSearch, centerId, forDate])

    const OnPageChange = (e) => {
        if (isActive && centerId && forDate) {
            const { value } = e.target;
            setCurrentPage(value)
            GetTodaysRegistered({
                CenterId: centerId,
                PageNo: value,
                PageSize: PAGE_SIZE,
                SearchTerm: searchTerm,
                ForDate: forDate
            })
        }
    }

    const onSearch = () => {
        GetTodaysRegistered({
            CenterId: centerId,
            PageNo: 1,
            PageSize: PAGE_SIZE,
            SearchTerm: searchTerm,
            ForDate: forDate
        })
    }

    const GetTodaysRegistered = (params) => {
        setLoding(true)
        start()
        opdRegisteredCrud.GetForDateRegistered(params).then(res => {
            let mdata = res.data
            if (mdata.result.succeeded) {
                setUserData(mdata.data)
                setPagingData(mdata.paging)
                setLastPage(mdata.paging.pageCount)
            } else {
                setPagingData()
                setLastPage(1)
                setUserData([])
                toast.open(mdata.result.message, <MdErrorOutline />, "danger")
            }
            setLoding(false)
            end()
        }).catch(errors => {
            setPagingData()
            setLastPage(1)
            setUserData([])
            setLoding(false)
            end()
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }

    const confirmOnline = (param, setValues) => {
        setLodingCrud(true)
        start()
        opdRegisteredCrud.ConfirmOnline(param).then(res => {
            let mdata = res.data
            if (mdata.result.succeeded) {
                setValues({
                    Id: 0,
                    Comment: "N/A",
                    BloodPressure: "N/A",
                })
                setIsOpenAdd(false)
                onSearch()
                toast.open(
                    <div className='flex flex-col'>
                        <span>Confirmed Successfully! Ref No: {mdata.data.id}</span>
                        <a href={`/#/checkconfirmed/${mdata.data.id}`} target='_blank' className='hover:underline text-blue-700 font-semibold' >Click to get confirmation details</a>
                    </div>
                    , <IoCheckmarkCircleOutline />, "success", 30000)
            } else {
                toast.open(mdata.result.message, <MdErrorOutline />, "danger")
                setIsOpenAdd(false)
            }
            setLodingCrud(false)
            end()
        }).catch(errors => {
            setLodingCrud(false)
            end()
            setIsOpenAdd(false)
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }

    return (
        <div class="text-gray-700">
            <div class="text-center text-2xl">
                <div class="px-4 py-2 font-semibold"></div>
                <Paging LastPage={LastPage} CurrentPage={currentPage} OnPageChange={OnPageChange} pagingData={pagingData} >
                    <div className='overflow-x-auto'>
                        <table class="border w-full text-sm text-left rtl:text-right text-gray-500 ">
                            <thead class="text-xs text-gray-700 uppercase bg-gray-200">
                                <tr>
                                    <th scope="col" class="px-3 py-3">
                                        Ref.No
                                    </th>
                                    <th scope="col" class="px-3 py-3">
                                        OPD No.
                                    </th>
                                    <th scope="col" class="px-3 py-3">
                                        Name
                                    </th>
                                    <th scope="col" class="px-3 py-3">
                                        Phone
                                    </th>
                                    <th scope="col" class="px-3 py-3">
                                        Age
                                    </th>
                                    <th scope="col" class="px-3 py-3">
                                        Action
                                    </th>
                                    <th scope="col" class="px-3 py-3">
                                        Address
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {loding ?
                                    <tr class="bg-white border-b hover:bg-gray-100">
                                        <td colSpan={7}>
                                            <LoadingContainer text="Fetching..." />
                                        </td>
                                    </tr>
                                    :
                                    userData.length > 0 ?
                                        userData.map((item, index) =>
                                            <tr class="bg-white border-b hover:bg-gray-100">
                                                <td class="px-3 py-2">
                                                    {item.id}
                                                </td>
                                                <td class="px-3 py-2">
                                                    {item.opdNumberAlloted}
                                                </td>
                                                <td class="px-3 py-2 font-bold text-nowrap">
                                                    {item.patientName} <span className='font-normal text-[9px]'>({GetEGenderName(item.gender)})</span>
                                                </td>
                                                <td class="px-3 py-2">
                                                    {item.mobile}
                                                </td>
                                                <td class="px-3 py-2">
                                                    {item.age}
                                                </td>
                                                <td class=" px-3 py-2 w-28">
                                                    {item.status == 2 ?
                                                        <button onClick={() => { setAddData(item.id); setIsOpenAdd(!isOpenAdd) }} type="button" className="text-sm font-medium text-white bg-brand-500 hover:bg-brand-600 focus:outline-none focus:ring-2 focus:ring-brand-500 rounded-lg px-3 py-1 transition pl-3 " title='Pending'>Confirm</button>
                                                        :
                                                        <StatusContainer bg={EOPDRegisteredStatusBg(item.status)} text={GetEOPDRegisterStatusName(item.status)} />
                                                    }
                                                </td>
                                                <td class="px-3 py-2 text-nowrap">
                                                    {item.patientAddress}
                                                </td>
                                            </tr>
                                        )
                                        :
                                        <tr class="bg-white border-b hover:bg-gray-100">
                                            <td colSpan={7} class="px-3 py-2">
                                                <Empty>
                                                    No Items Found.
                                                </Empty>
                                            </td>
                                        </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </Paging>

                <div class="pb-4"></div>
            </div >
            <ConfirmOnline ConfirmOnline={confirmOnline} id={addData} isOpen={isOpenAdd} setIsOpen={setIsOpenAdd} loding={lodingCrud} />
        </div >


    )
}
